import { io, Socket } from "socket.io-client";

// Tipagem do objeto salvo no localStorage com ID "1"
interface UserData {
  usuarioCliente?: {
    id: string;
  };
}

// URLs da config global
const URL: string = window?.config?.REACT_APP_BASE_URL || "";
// const URL_SISTEMA: string = window?.config?.REACT_APP_LINK_MW || "";
//const URL_SISTEMA: string = window?.config?.REACT_APP_LINK_MW || "";

// Recupera o ID do cliente do localStorage
let USUARIO_CLIENTE_ID = "";
const localData = localStorage.getItem("1");

if (localData) {
  try {
    const parsed: UserData = JSON.parse(localData);
    USUARIO_CLIENTE_ID = parsed?.usuarioCliente?.id || "";
  } catch (error) {
    console.error("Erro ao analisar localStorage '1':", error);
  }
}
const token = localData ? JSON.parse(localData)?.token : "";
// console.log("Token do localStorage:", token);

// Socket para cliente privado
export const socket: Socket = io(`${URL}/private`, {
  reconnection: true,
  autoConnect: false,
  query: {
    usuarioClienteId: USUARIO_CLIENTE_ID,
  },
  auth: {
    token,
  },
});

// Socket para sistema (middleware)
// // Socket para sistema (middleware)
// export const socket: Socket = io(URL_SISTEMA, {
//   reconnection: true,
//   autoConnect: false,
//   auth: {
//     token: window?.config?.REACT_APP_MW_SISTEMA_TOKEN || "",
//   },
// });
